import mixpanel, { Callback } from 'mixpanel-browser';
import { isPWAinStandalone, isBtoCFlow } from './common-utils';
import { getAgentCode, getUserDetails } from './storage';
import { Dict } from './type';
import { getEncryptedUserId } from '__utils/common-utils';

const { pushToGTMDataLayer,IdentifyUserForMXP } = require("turtlefin-analytics-wrapper");

export declare type MinxpanelEventType = 'changed' | 'clicked' | 'entered' | 'loaded' | 'selected' | 'completed';

export const gtmPixel = (gtmKey: any) => {
	(function (w:any, d, s, l:any, i) {
	  w[l] = w[l] || [];
	  w[l].push({
		'gtm.start': new Date().getTime(),
		event: 'gtm.js'
	  });
	  var f:any = d.getElementsByTagName(s)[0],
		j:any = d.createElement(s),
		dl = l != 'dataLayer' ? '&l=' + l : '';
	  j.async = true;
	  j.src =
		'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
	  f.parentNode.insertBefore(j, f);
	})(window, document, 'script', 'dataLayer', gtmKey);
  };

export const identify = (params: any)=>{
    const _gtmObj:any = {};
    _gtmObj.source = 'mintpro';
    _gtmObj.p_id = params;
    IdentifyUserForMXP(_gtmObj); 
	gtmPixel('GTM-5MHLGZ2');     
}

export const getEventName = (eventName: string, eventType: MinxpanelEventType, page?: string) => {
	if (!page)
	{
		let fullPath = window.location.pathname;
		if (fullPath)
		{
			let paths = fullPath.split('/');
			if (paths && paths.length)
			{
				page = paths[ paths?.length - 1 ]
			}
		}
	}
	if (!page)
	{
		page = window.location.pathname.substr(1);
	}
	return `MF-${page ? page : 'home'}-${eventName}-${eventType}`;
}

const convertDataToGALabel = (jsonObject: any): string => {
	return Object.keys(jsonObject).map(function (key) {
		if (!!jsonObject[ key ] && (typeof jsonObject[ key ] === 'string' || typeof jsonObject[ key ] === 'boolean'))
		{
			return key + ' : ' + jsonObject[ key ];
		} else
		{
			return '';
		}
	})
		.filter(function (ele) {
			return ele;
		})
		.join(';');
}
const getDefaultTrackingProps = (name: string) => {
	return {
		agentCode: getAgentCode(),
		user: getUserDetails(),
		isBtoCFlow: isBtoCFlow(),
		eventName: name,
		language: 'en-us',
		vertical: 'MF',
		isPWA: isPWAinStandalone(),
		userId: getAgentCode(),
	}
}

const actions = {
	identify: (id: string) => {
		mixpanel.identify(id);
	},
	alias: (id: string) => {
		mixpanel.alias(id);
	},
	track: (name: string, props?: Dict<any>) => {
		const data = {
			...{
				...getDefaultTrackingProps(name),
				gaAction: name,
				gaLabel: convertDataToGALabel({ ...getDefaultTrackingProps(name), ...(props ? props : {}) }),
				gaValue: "",
				gaCategory: "MF",
				event: "track_events",
				eventName: name,
				source: "mutual-fund",
			}, ...props
		};		
		pushToGTMDataLayer(data);
	},
	people: {
		set: (props: Dict<any>) => {
			mixpanel.people.set(props);
		}
	}
};

export const Mixpanel = actions;
